import { isBoolean, isNil, isObject, isString } from '@pct-ts/typeguard';

export type TranslateAble = { text: string; translateParams?: unknown; translate: boolean };
export type TranslateAbleText = string | TranslateAble;

export function isTranslateAbleText(value: unknown): value is TranslateAble {
  return (
    isString(value) ||
    (isObject(value) &&
      !isNil(value) &&
      'text' in value &&
      isString(value.text) &&
      'translate' in value &&
      isBoolean(value.translate))
  );
}
